<template>
  <div>
    <v-container v-if="!loading && companies.length > 1 && !demoMode" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <v-card outlined  v-if="!loading" class="mt-4">
      <v-card-text>
 
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex md6 xs12>
            <h1 class="tab-title">Algemene instellingen</h1>
          </v-flex>
          <v-flex md6 xs12>
            <div style="display: inline-block; float: right;">
              <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :loading="updateMessageSettingsBusy" :disabled="!changed" :depressed="!changed" @click="updateMessageSettings()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-switch
              class="mt-3 pa-0"
              label="Sms versturen naar klant vóór bezoek aan salon."
              v-model="activeCompData.smsActive"
              :color="companyPrimaryColor"
            ></v-switch>
          </v-flex>
        </v-layout>
        <div v-if="activeCompData.smsActive">
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                class="mt-1"
                item-text="name"
                item-value="id"
                :items="languages"
                v-model="selectedLanguage"
                label="Selecteer taal"
                outlined
                hide-details
                background-color="background"
                color="primary"
                item-color="primary"
              >
              <template v-slot:prepend-inner>
                <div style="margin: 2px px 0 0">
                  <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                  <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
                </div>
              </template>
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pt-4">
            <v-flex md4 xs12>
              <h3><strong>Bericht dat 12 uur voor bezoek wordt verzonden</strong></h3>
              <v-textarea
                class="pt-2"
                v-model="activeCompData.smsContent.message[selectedLanguage]"
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].background"
                required
                rows="10"
                no-resize
                outlined
                counter
                maxlength="152"
              ></v-textarea>
            </v-flex>
            <v-flex md4 xs12>
              <h3><strong>Reactie op klant met klachten</strong></h3>
              <v-textarea
                class="pt-2"
                v-model="activeCompData.smsContent.responseYes[selectedLanguage]"
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].background"
                required
                rows="10"
                no-resize
                outlined
                counter
                maxlength="152"
              ></v-textarea>
            </v-flex>
            <v-flex md4 xs12>
               <h3><strong>Reactie op klant zonder klachten</strong></h3>
              <v-textarea
                class="pt-2"
                v-model="activeCompData.smsContent.responseNo[selectedLanguage]"
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].background"
                required
                rows="10"
                no-resize
                outlined
                counter
                maxlength="152"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        </v-container>
      </v-card-text>
    </v-card>


  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import db from "../firebase/init";
import platform from 'platform'; 

export default {
  name: "SmsMessageSettings",

  data: () => ({
    updateMessageSettingsBusy: false,
    selectedLanguage: "nl",
    languages: [
      {
        name: "Nederlands",
        id: 'nl'
      },
      {
        name: "Engels",
        id: 'en'
      }     
    ],
    loading: true,
    feedback: null,
    activeCompData: {},
    searchCompanies: "",
    activeCompDataOriginal: {},
    companies: [],
    activeComp: "", 
  }),

  created() {
    this.loadUserComp();
  },

  methods: {
    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
          if(this.activeCompData.conversion.sources && this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(conversieItem =>{
              conversieItem.copy = false
            })
          }
        })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    updateMessageSettings(){
      this.updateMessageSettingsBusy = true;
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          smsActive: this.activeCompData.smsActive,
          smsContent: this.activeCompData.smsContent,
        }, { merge: true })
        .then(()=>{
          this.activeCompDataOriginal.smsActive = _.cloneDeep(this.activeCompData.smsActive);
          this.activeCompDataOriginal.smsContent = _.cloneDeep(this.activeCompData.smsContent);
        })
        .then(()=>{
          this.updateMessageSettingsBusy = false;
        })
        .catch(error=>{
          console.error("Updaten niet gelukt: ", error)
        })
    }
  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },
    changed() {
      if (_.isEqual(this.activeCompData.smsActive, this.activeCompDataOriginal.smsActive) == false ||
      _.isEqual(this.activeCompData.smsContent, this.activeCompDataOriginal.smsContent) == false) {
        return true;
      } else {
        return false;
      }
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
 
  }
};
</script>
